//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 16/09/2023
// Version       : 1
// Description   : Dialog para agregar tareas segun tipo de vehiculo
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
  Autocomplete,
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  Tooltip,
  Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";

// ICONOS
import HelpIcon from "@mui/icons-material/Help";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AgregarTareaTipoVehiculos(props) {
  const [tipoVehiculos, setTipoVehiculos] = useState();
  const [datosTareaTipoVehiculos, setDatosTareaTipoVehiculos] = useState({
    tarea: null,
    frecuencia: null,
    id_parte: null,
  });
  const [selectedValue, setSelectedValue] = useState("");
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // ---------------------------------------------------------

  const obtenerTipoVehiculos = () => {
    fetch(UrlApi + "/tipos_vehiculos")
      .then((data) => data.json())
      .then((data) => setTipoVehiculos(data));
  };

  useEffect(() => {
    obtenerTipoVehiculos();
  }, []);

  // AUTOCOMPLETE
  const [tipoVehiculoSeleccionado, setTipoVehiculoSeleccionado] =
    useState(null);

  // ------------------------------------------------------------------------

  const [frecuenciaTareas, setFrecuenciaTareas] = useState([]);

  const obtenerFrecuenciaTareas = () => {
    fetch(UrlApi + "/tareas_tipo_vehiculos/frecuencia_tareas")
      .then((data) => data.json())
      .then((data) => setFrecuenciaTareas(data));
  };

  const [frecuenciaKM, setFrecuenciaKM] = useState([]);

  const obtenerFrecuenciaKM = () => {
    fetch(UrlApi + "/frecuencia_kilometros")
      .then((data) => data.json())
      .then((data) => setFrecuenciaKM(data));
  };

  useEffect(() => {
    obtenerFrecuenciaTareas();
    obtenerFrecuenciaKM();
  }, []);

  // ------------------------------------------------------------------------

  const [partesVehiculo, setPartesVehiculo] = useState([]);

  const obtenerPartesVehiculo = () => {
    fetch(UrlApi + "/vehiculos_partes")
      .then((data) => data.json())
      .then((data) => setPartesVehiculo(data));
  };

  useEffect(() => {
    obtenerPartesVehiculo();
  }, []);

  //*************************************************************************************************************************************/

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  //*************************************************************************************************************************************/

  //Función GUARDAR
  const guardarCrear = async (e) => {
    console.log("Estoy por guardar");
    setDisBtn(true);
    e.preventDefault();

    // Determinar si la frecuencia seleccionada corresponde a 'frecuenciaTareas' o 'frecuenciaKM'
    const frecuenciaSeleccionada =
      frecuenciaTareas.find((item) => item.id === selectedValue) || null;
    const frecuenciaKmSeleccionada =
      frecuenciaKM.find((item) => item.id_frecuencia_km === selectedValue) ||
      null;

    const frecuenciaValor = frecuenciaSeleccionada
      ? frecuenciaSeleccionada.id
      : "";
    const frecuenciaKmValor = frecuenciaKmSeleccionada
      ? frecuenciaKmSeleccionada.id_frecuencia_km
      : "";

    await fetch(UrlApi + "/tareas_tipo_vehiculos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_tipo: tipoVehiculoSeleccionado?.id,
        tarea: datosTareaTipoVehiculos.tarea,
        // Guardar solo la frecuencia seleccionada
        frecuencia: frecuenciaValor ? frecuenciaValor : null,
        frecuencia_km: frecuenciaKmValor ? frecuenciaKmValor : null,
        parte_vehiculo: datosTareaTipoVehiculos.parte_vehiculo,
        estado: 1,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La tarea se guardó exitosamente!");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar la tarea");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const almacenar = (e) => {
    setDatosTareaTipoVehiculos({
      ...datosTareaTipoVehiculos,
      [e.target.name]: e.target.value,
    });
  };

  //  ------------------------------------------------------------------------

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setDisBtn(false);
    datosTareaTipoVehiculos.tarea = "";

    props.onTareaGuardada(); // Función para obtener valores de nuevo en el componente padre
  };

  return (
    <>
      <Box
        style={{
          borderWidth: 2,
          borderStyle: "solid",
          border: "2px solid #2B76A6",
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 2,
            display: "flex",
            justifyContent: "flex-start", // alineado a la izquierda
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              backgroundColor: "#2B76A6",
              borderBottomRightRadius: "12px", // solo esquina inferior derecha
              padding: "8px 18px",
            }}
          >
            Agregar Tarea
          </Typography>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarCrear}>
            <Grid container mt={1} mb={2} spacing={1}>
              <Grid item xs={4}>
                <Autocomplete
                  size="small"
                  disableClearable
                  noOptionsText={"Tipos No Disponibles"}
                  options={tipoVehiculos}
                  autoHighlight
                  getOptionLabel={(tipo_vehiculos) =>
                    tipo_vehiculos.tipo_vehiculo
                  }
                  onChange={(event, value) =>
                    setTipoVehiculoSeleccionado(value)
                  }
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.tipo_vehiculo}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      placeholder="Tipee para buscar..."
                      required
                      {...params}
                      label="Tipo de Vehículo"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Frecuencia</InputLabel>
                  <Select
                    value={selectedValue}
                    onChange={handleChange}
                    defaultValue=""
                    label="Frecuencia"
                    required
                  >
                    <MenuItem
                      value=""
                      sx={{ fontSize: "0.9rem", padding: "4px 12px" }}
                    >
                      <em>Ninguna</em>
                    </MenuItem>
                    {/* Grupo 1: Frecuencia por Tiempo */}
                    <ListSubheader
                      sx={{
                        bgcolor: "lightgray",
                        margin: "0",
                        padding: "2px 8px",
                      }}
                    >
                      Tiempo
                    </ListSubheader>
                    {frecuenciaTareas.map((item, index) => (
                      <MenuItem
                        key={`tarea-${index}`}
                        value={item.id}
                        sx={{ fontSize: "0.9rem", padding: "4px 12px" }}
                      >
                        {item.valor}
                      </MenuItem>
                    ))}
                    {/* Grupo 2: Frecuencia por KM */}
                    <ListSubheader
                      sx={{
                        bgcolor: "lightgray",
                        margin: "0",
                        padding: "2px 8px",
                      }}
                    >
                      Distancia
                    </ListSubheader>
                    {frecuenciaKM.map((item, index) => (
                      <MenuItem
                        key={`km-${index}`}
                        value={item.id_frecuencia_km}
                        sx={{ fontSize: "0.9rem", padding: "4px 12px" }}
                      >
                        {item.valor_km} km
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={0.6}>
                <Tooltip
                  title={
                    <div>
                      <strong style={{ color: "lightblue", fontSize: "14px" }}>
                        Diario:
                      </strong>{" "}
                      <text style={{ fontSize: "14px" }}>Todos los días </text>
                      <br />
                      <strong style={{ color: "lightblue", fontSize: "14px" }}>
                        Semanal:
                      </strong>{" "}
                      <text style={{ fontSize: "14px" }}>Cada siete días </text>
                      <br />
                      <strong style={{ color: "lightblue", fontSize: "14px" }}>
                        Quincenal:
                      </strong>{" "}
                      <text style={{ fontSize: "14px" }}>Cada dos semanas</text>
                      <br />
                      <strong style={{ color: "lightblue", fontSize: "14px" }}>
                        Mensual:
                      </strong>{" "}
                      <text style={{ fontSize: "14px" }}>
                        {" "}
                        Cada treinta días
                      </text>
                    </div>
                  }
                  placement="top"
                  arrow
                  disableInteractive
                  sx={{
                    "& .MuiTooltip-tooltip": {
                      fontSize: "2rem", // Tamaño de la fuente
                    },
                  }}
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, 7],
                          },
                        },
                      ],
                    },
                  }}
                >
                  {" "}
                  <HelpIcon sx={{ mt: 0.9, ml: 0.2 }} />
                </Tooltip>
              </Grid>

              <Grid item xs={4.4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Parte del Vehículo</InputLabel>
                  <Select
                    name="parte_vehiculo"
                    value={datosTareaTipoVehiculos.parte_vehiculo}
                    onChange={almacenar}
                    label="Parte del Vehículo"
                    required
                  >
                    {partesVehiculo.map((opcion) => (
                      <MenuItem key={opcion.id_parte} value={opcion.id_parte}>
                        {opcion.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container mb={2} spacing={1}>
              <Grid item xs={12}>
                <TextField
                  label="Descripción"
                  fullWidth
                  required
                  size="small"
                  name="tarea"
                  autoComplete="off"
                  value={datosTareaTipoVehiculos.tarea}
                  onChange={almacenar}
                />
              </Grid>
            </Grid>

            <Grid container direction={{ xs: "column", sm: "row" }}>
              <Grid item xs={9}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={props.handleCloseAgregarTarea}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={disBtn}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregarTareaTipoVehiculos;
